import { useNotify } from '@/composables/index';
import { useAppointmentAnalytics } from '@/composables/useAppointmentAnalytics';

export default function useGMAd(warehouse, org, entryPoint) {
  const notify = useNotify();
  const { trackSelfCheckInCtaClicked, trackGateManagementRequested } = useAppointmentAnalytics();
  const baseMixpanelData = {
    'Warehouse ID': warehouse.id,
    'Warehouse Name': warehouse.name,
    'Org ID': warehouse.orgId,
    'Org Name': org ? org.name : 'Unknown Org Name'
  };
  const handleGMCTAClick = () => {
    trackSelfCheckInCtaClicked({
      ...baseMixpanelData,
      'Entry Point': entryPoint
    });
  };

  const handleGMRequestClick = () => {
    trackGateManagementRequested({
      ...baseMixpanelData,
      'Entry Point': entryPoint
    });
    notify('Thank you! Our team will contact you soon.', 'success');
  };

  return {
    handleGMCTAClick,
    handleGMRequestClick
  };
}
